import React from "react";
import { useContext } from "react";
import { QuestionContext } from "../../context";
import { OptionsSingle } from "../OptionsSingle";
import { OptionsMulti } from "../OptionsMulti";
import { OptionsJudge } from "../OptionsJudge";
import classNames from "classnames";

export function Options({ className, style, children }: RenderComponent) {
    const ctx = useContext(QuestionContext);

    return (
        <div className={classNames("QuestionOptions", className)} style={style}>
            {ctx.type === "SingleChoice" && <OptionsSingle />}
            {ctx.type === "MultiChoice" && <OptionsMulti />}
            {ctx.type === "Judge" && <OptionsJudge />}

            {children}
        </div>
    );
}
